module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_bice.7616c342.svg";